import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  display: inline-flex;
`;

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.4px;
  border-radius: 999px;
  white-space: nowrap;
  color: var(--cp-text-secondary, #5b6770);
  background: var(--cp-surface-alt, #fafbfc);
  border: 1px solid var(--cp-border, #e5e7eb);
  transition: color 0.15s ease, border-color 0.15s ease;

  &:hover {
    color: var(--cp-green, #47b972);
    border-color: var(--cp-green, #47b972);
  }

  .caret {
    width: 9px;
    height: 9px;
    opacity: 0.6;
    transition: transform 0.18s ease;
  }
  &[aria-expanded='true'] .caret {
    transform: rotate(180deg);
  }
`;

export const Menu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 120px;
  padding: 6px;
  z-index: 60;
  border-radius: 12px;
  background: var(--cp-surface, #fff);
  border: 1px solid var(--cp-border, #e5e7eb);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.18);
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-align: left;
  color: ${(props) => (props.$active ? 'var(--cp-green, #47b972)' : 'var(--cp-text, #2a3134)')};
  background: ${(props) => (props.$active ? 'rgba(71, 185, 114, 0.12)' : 'transparent')};
  transition: background 0.12s ease, color 0.12s ease;

  &:hover {
    background: ${(props) => (props.$active ? 'rgba(71, 185, 114, 0.16)' : 'var(--cp-surface-hover, #f5f7f6)')};
  }
`;
